var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchaseHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#FFEACC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8H12C9 8 8 9.79 8 12V13V27C8 27.83 8.94 28.3 9.6 27.8L11.31 26.52C11.71 26.22 12.27 26.26 12.63 26.62L14.29 28.29C14.68 28.68 15.32 28.68 15.71 28.29L17.39 26.61C17.74 26.26 18.3 26.22 18.69 26.52L20.4 27.8C21.06 28.29 22 27.82 22 27V10C22 8.9 22.9 8 24 8H13ZM11.97 20.01C11.42 20.01 10.97 19.56 10.97 19.01C10.97 18.46 11.42 18.01 11.97 18.01C12.52 18.01 12.97 18.46 12.97 19.01C12.97 19.56 12.52 20.01 11.97 20.01ZM11.97 16.01C11.42 16.01 10.97 15.56 10.97 15.01C10.97 14.46 11.42 14.01 11.97 14.01C12.52 14.01 12.97 14.46 12.97 15.01C12.97 15.56 12.52 16.01 11.97 16.01ZM18 19.76H15C14.59 19.76 14.25 19.42 14.25 19.01C14.25 18.6 14.59 18.26 15 18.26H18C18.41 18.26 18.75 18.6 18.75 19.01C18.75 19.42 18.41 19.76 18 19.76ZM18 15.76H15C14.59 15.76 14.25 15.42 14.25 15.01C14.25 14.6 14.59 14.26 15 14.26H18C18.41 14.26 18.75 14.6 18.75 15.01C18.75 15.42 18.41 15.76 18 15.76Z",
    fill: "#FF671E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.01 8V9.5C24.67 9.5 25.3 9.77 25.76 10.22C26.24 10.71 26.5 11.34 26.5 12V14.42C26.5 15.16 26.17 15.5 25.42 15.5H23.5V10.01C23.5 9.73 23.73 9.5 24.01 9.5V8ZM24.01 8C22.9 8 22 8.9 22 10.01V17H25.42C27 17 28 16 28 14.42V12C28 10.9 27.55 9.9 26.83 9.17C26.1 8.45 25.11 8.01 24.01 8C24.02 8 24.01 8 24.01 8Z",
    fill: "#FF671E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseHistory);
export default __webpack_public_path__ + "static/media/purchase-history.63c5655fcb801cce57a32c133c411690.svg";
export { ForwardRef as ReactComponent };